module.exports = __webpack_public_path__ + "img/tick-green.1cc5ea31.svg";